import { useEffect, useState,useCallback } from "react";
import { DataGrid, gridPageCountSelector, gridPageSelector, useGridSelector, useGridApiRef } from '@mui/x-data-grid';
import { Box, Button, Container, Typography, Pagination, PaginationItem, useMediaQuery, TextField, MenuItem} from '@mui/material';
import { LocalOffer } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import { callPostApi } from "../../API/ApiCallFunction";
import GradientLoader from "../../CommanComponents/GradientLoader";
import ReusableDialog from "../../CommanComponents/ReusableDialog";
import { useNavigate } from "react-router-dom";
import FullImgPreview from "../../CommanComponents/FullImgPreview";

function CustomToolbar({ onAddCampaign }) {
  return ( <Box> <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={onAddCampaign}> Campaign </Button></Box>);}

function CustomPagination({ apiRef, isMobile }) {
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  const handlePageChange = (_, value) => {
    apiRef.current.setPage(value - 1);

    if (isMobile && apiRef.current) {
      setTimeout(() => {
        apiRef.current.autosizeColumns({ includeHeaders: true });
      }, 0);
    }
  }; return (
    <Pagination color="primary" variant="outlined" shape="rounded"
      page={page + 1}
      count={pageCount}
      renderItem={(props2) => <PaginationItem {...props2} disableRipple />}
      onChange={handlePageChange}
    />
  );
}

export function RedeemedList() {
  const isMobile = useMediaQuery("(max-width:768px)");
  const navigate = useNavigate();
  const user = JSON.parse(sessionStorage.getItem("user") || "{}");
  const apiRef = useGridApiRef();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [datar, setDatar] = useState([]);
  const [filterLimit, setFilterLimit] = useState(100);
  const [paginationModel, setPaginationModel] = useState({ pageSize: 10, page: 0,});
  const handleAddCampaign = () => setOpen(true);
  const handleClose = () => setOpen(false);

 const columns = [
    { field: "sr", headerName: "Sr no.", flex: isMobile ? undefined : 0.5 },
    { field: "offerlogo", headerName: "Coupon Image", flex: isMobile ? undefined : 1,
      renderCell: (params) => { if (!params.value || params.value === "NA") { return <Typography variant="body2">No Image</Typography>; }
                   return <FullImgPreview src={params.value} />;  }, },
    { field: "ctitle", headerName: "Coupon Title", flex: isMobile ? undefined : 1,},
    { field: "custname", headerName: "Customer", flex: isMobile ? undefined : 1,},
    { field: "activedate", headerName: "Issued Date", flex: isMobile ? undefined : 1 },
    { field: "redeemdate", headerName: "Redeem Date", flex: isMobile ? undefined : 1 },
  ];

  // API call 
  const redeemedApi =  useCallback(async () => {
    try {
      setLoading(true);
      const storeid = user.store_info?.store_id;
      const payload = { mod: "CASHI_REDEEM_COUPON", data_arr: { store_id: storeid, start: 0, limit:filterLimit,},};
      const apiResult = await callPostApi("cashi-customer", payload);
      if (apiResult.status === "200" && Array.isArray(apiResult.data)) {
        const formattedData = apiResult.data.map((item, index) => ({
          id:item.coupon_id,
          sr: index + 1,
          activedate: item.genereate_date || "NA",
          redeemdate: item.redeem_date || "NA",
          ctitle: item.offer_title || "NA",
          offerlogo: item.offer_logo || "NA",
          custname: item.cust_name +"/"+item.cust_mobile|| "NA",
        
        }));
        setDatar(formattedData); 
      } else { setDatar([]);}
    } finally { setLoading(false);}
  },[user.store_info?.store_id, filterLimit]);

  useEffect(() => {
  redeemedApi();
}, [redeemedApi]);

  return (
    <Container sx={{ my: 2 }}>

      <Box sx={{ display: "flex", justifyContent: "start", mb: 2 }}>
        <Button  variant="contained"  sx={{ backgroundColor: "#000000", color: "#ffffff" }} onClick={() => navigate(-1)}>
          Back
        </Button>
      </Box>

      {/* Title */}
      <Typography ariant="h6"  gutterBottom
        sx={{ background: "linear-gradient(195deg, #49a3f1, #1A73E8)",  p: 1, color: "#ffffff",
          borderRadius: "4px", mb: 3, display: "flex", alignItems: "center",}} >
        <LocalOffer sx={{ mr: 1 }} /> Redeemed Coupons
      </Typography>

      {/* Toolbar */}
      <Box sx={{ mb: 2, display: "flex", justifyContent: "end" }}> <CustomToolbar onAddCampaign={handleAddCampaign} /></Box>
         <Box sx={{my:2}}>
           <TextField  select label="Limit" value={filterLimit} onChange={(e) => { setFilterLimit(e.target.value);}}
             sx={{ minWidth: 140, }}>
              <MenuItem value={100}>100</MenuItem>
              <MenuItem value={300}>300</MenuItem>
              <MenuItem value={500}>500</MenuItem>
              <MenuItem value={2000}>All</MenuItem>
           </TextField>
           <Button variant="outlined" color="primary"  sx={{ height: 56 , mx:1}} onClick={() => { redeemedApi();}}> Apply Filter </Button>
          </Box>

      {/* DataGrid */}
      <Box sx={{ height: "auto", width: "100%", mb: 4 }}>
        <DataGrid apiRef={apiRef} rows={datar} columns={columns} showToolbar disableRowSelectionOnClick checkboxSelection
          paginationModel={paginationModel} onPaginationModelChange={setPaginationModel} getRowHeight={() => "auto"}
          slots={{ pagination: () => <CustomPagination apiRef={apiRef} isMobile={isMobile} />,}}
          sx={{
            "& .MuiDataGrid-cell": {
              whiteSpace: "normal",
              wordBreak: "break-word",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#f0f0f0",
              color: "#000",
              fontWeight: "bold",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontSize: 14,
              fontWeight: 600,
              whiteSpace: "normal",
              wordBreak: "break-word",
            },
          }}
        />
      </Box>

      <ReusableDialog open={open} onClose={handleClose} />    {/* Add Campaign Dialog */}
      {loading && <GradientLoader text="Loading" />}
    </Container>
  );
}
